var _circle, _mask, _path, _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLbtCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 593,
    height: 593,
    viewBox: "0 0 593 593",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 296.5,
    cy: 296.5,
    r: 296.5,
    fill: "#181D1C"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_419_376",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M413.843 387.357C420.871 392.799 422.211 402.971 416.109 409.433C402.631 423.709 386.674 435.488 368.971 444.176C346.441 455.233 321.679 460.987 296.582 461C271.485 461.012 246.718 455.282 224.176 444.248C206.465 435.578 190.496 423.814 177.004 409.552C170.895 403.096 172.225 392.923 179.247 387.474V387.474C186.27 382.026 196.316 383.384 202.576 389.693C212.952 400.151 225.029 408.829 238.327 415.339C256.458 424.214 276.379 428.823 296.566 428.813C316.752 428.803 336.669 424.174 354.791 415.281C368.083 408.758 380.151 400.067 390.517 389.6C396.771 383.284 406.815 381.916 413.843 387.357V387.357Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M413.843 387.357C420.871 392.799 422.211 402.971 416.109 409.433C402.631 423.709 386.674 435.488 368.971 444.176C346.441 455.233 321.679 460.987 296.582 461C271.485 461.012 246.718 455.282 224.176 444.248C206.465 435.578 190.496 423.814 177.004 409.552C170.895 403.096 172.225 392.923 179.247 387.474V387.474C186.27 382.026 196.316 383.384 202.576 389.693C212.952 400.151 225.029 408.829 238.327 415.339C256.458 424.214 276.379 428.823 296.566 428.813C316.752 428.803 336.669 424.174 354.791 415.281C368.083 408.758 380.151 400.067 390.517 389.6C396.771 383.284 406.815 381.916 413.843 387.357V387.357Z",
    fill: "#77ECFE",
    stroke: "#77ECFE",
    strokeWidth: 1326,
    mask: "url(#path-2-inside-1_419_376)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 366,
    y: 197,
    width: 95,
    height: 125,
    rx: 26,
    fill: "#77ECFE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 197,
    width: 95,
    height: 125,
    rx: 26,
    fill: "#77ECFE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 394,
    y: 160,
    width: 38,
    height: 197,
    rx: 19,
    fill: "#77ECFE"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 160,
    width: 38,
    height: 197,
    rx: 19,
    fill: "#77ECFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLbtCoin);
export default __webpack_public_path__ + "static/media/lbtCoin.c5944e21d45d44f03503523ba44b918e.svg";
export { ForwardRef as ReactComponent };